import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PlaceholderText from 'components/PlaceholderText';
import { PublishStatusCircle } from 'components/PublicationStatusMarkets/styles';
import PublicationMarketsTooltip from 'components/PublicationStatusMarkets/PublicationMarketsTooltip';
import { getActivityLiveDetails } from 'builder/utils';
import messages from './messages';
import { PUBLICATION_STATUS } from 'constants/constants';
import { getPublicationOutputSummary } from 'utils/getPublicationOutputSummary';

const PublicationStatusCircle = ({ activityId, theme }) => {
  const [status, setStatus] = useState(null);
  const [marketsExist, setMarketsExist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    if (!activityId) return;
    const fetchActivityDetails = async () => {
      setIsLoading(true);
      try {
        const liveDetails = await getActivityLiveDetails(activityId);
        if (liveDetails && Array.isArray(liveDetails)) {
          const summary = getPublicationOutputSummary(
            liveDetails,
            'pearsonPlusStatus',
          );
          setStatus(summary.currentStatus);
          setMarketsExist(summary.marketsExist);
          setMarkets(summary.markets);
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error("Error fetching activity live details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchActivityDetails();
  }, [activityId]);

  if (isLoading) {
    return <PlaceholderText height={10} minWidth={10} maxWidth={10} marginLeft={4} />;
  }

  const statusMapping = {
    [PUBLICATION_STATUS.IN_REVIEW]: { color: theme['color.magenta'] },
    [PUBLICATION_STATUS.PUBLISHED_LIVE]: { color: theme['color.green'] },
  };

  if (!status || !statusMapping[status]) {
    return null;
  }

  const { color } = statusMapping[status];

  return (
    <PublishStatusCircle
      color={color}
      marketsExist={marketsExist}
      marginLeft={4}
    >
      <PublicationMarketsTooltip
        markets={markets}
        marketsExist={marketsExist}
        theme={theme}
        messages={messages}
      />
    </PublishStatusCircle>
  );
};

PublicationStatusCircle.propTypes = {
  activityId: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

export default PublicationStatusCircle;